import React from "react";
import type { RegisterBy } from "../useEnrolmentForm";

interface RegisterBySectionProps {
  value: RegisterBy | "";
  onChange: (v: RegisterBy) => void;
  disabled?: boolean;
}

const RegisterBySection: React.FC<RegisterBySectionProps> = ({ value, onChange, disabled }) => {
  return (
    <div className="d-flex gap-3">
      {(["self", "parent"] as RegisterBy[]).map((opt) => (
        <button
          key={opt}
          type="button"
          className={`enrolment-option-card${value === opt ? " selected" : ""}${disabled ? " disabled" : ""}`}
          onClick={() => !disabled && onChange(opt)}
          disabled={disabled}
        >
          <span className="enrolment-option-radio">
            <span className={`enrolment-option-dot${value === opt ? " active" : ""}`} />
          </span>
          <span className="enrolment-option-label">
            {opt === "self" ? "Self" : "Parent / Guardian"}
          </span>
          <span className="enrolment-option-desc text-muted" style={{ fontSize: 12 }}>
            {opt === "self"
              ? "The player is registering themselves"
              : "Registering a child"}
          </span>
        </button>
      ))}
    </div>
  );
};

export default RegisterBySection;
